<div fxLayout="row" fxLayoutAlign="center center" class="ab-test-editing-toggle" [class.ab-test-editing-toggle--active]="enabled">
  <mat-icon fxFlex="nogrow"
            [class.active]="!enabled" class="indicator-mode mode--live"
            [matTooltip]="'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.LIVE' | translate"
            matTooltipPosition="above">
    edit
  </mat-icon>

  <mat-slide-toggle fxFlex="nogrow"
                     [checked]="enabled"
                     [disabled]="disabled"
                     (change)="changeEnabled($event)"
                     [matTooltip]="(disabled ? 'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.DISABLED_TOOLTIP' : 'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.TOOLTIP') | translate">
  </mat-slide-toggle>

  <mat-icon fxFlex="nogrow"
            [class.active]="enabled" class="indicator-mode mode--variant"
            [matTooltip]="'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.VARIANT' | translate"
            matTooltipPosition="above">
    science
  </mat-icon>

  @if (enabled) {
    <!-- Badge texte toujours visible (pas seulement un tooltip au survol) : les icônes/toggle seuls sont trop
         discrets pour signaler sans ambiguïté qu'on édite la variante B plutôt que la source live, notamment quand
         ce mode a été activé sur un autre onglet et qu'on arrive ici avec l'état déjà actif (cf. persistance
         volontaire de `abTestEditingSelection` entre les onglets Template / Éditorial / Configuration). -->
    <span class="ab-test-badge" fxFlex="nogrow">{{ 'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.BADGE' | translate }}</span>

    <mat-form-field appearance="outline" class="ab-test-select" fxFlex="nogrow" subscriptSizing="dynamic">
      <mat-select [value]="selectedTest" [compareWith]="compareTests" (selectionChange)="changeSelectedTest($event.value)">
        @for (test of editableTests; track test.id.id) {
          <mat-option [value]="test">
            {{ test.label }}
            <span class="ab-test-status-badge" [class.ab-test-status-badge--running]="getStatus(test) === 'running'">
              {{ (getStatus(test) === 'running' ? 'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.STATUS.RUNNING' : 'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.STATUS.SCHEDULED') | translate }}
            </span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (selectedTestIsRunning) {
      <!-- Ce test est déjà en cours : la variante B éditée ici est potentiellement déjà servie au trafic live (cas
           rare en pratique — une campagne s'exécute en général une fois par jour, en quelques minutes — mais à
           signaler explicitement plutôt que de laisser croire qu'on édite un test qui n'a pas encore démarré). -->
      <mat-icon fxFlex="nogrow"
                class="ab-test-running-warning"
                [matTooltip]="'NEWSLETTERS.AB_TEST.EDITING_TOGGLE.RUNNING_WARNING' | translate"
                matTooltipPosition="above">
        warning
      </mat-icon>
    }
  }
</div>
